import ninegrid from "../index.js";
import { ngEditableEx } from "./_ngCell.js";

class ngCheckBox extends ngEditableEx
{
	#target;
	#label;
	#isRadio;
	#trueText;
	#falseText;
	
	constructor () {
		super();

		this.applyBaseStyle();

		this.trueValue	= this.getAttribute("true-value") || "Y";
		this.falseValue	= this.getAttribute("false-value") || "N";
		this.#trueText	= this.getAttribute("true-text") || "";//this.trueValue;
		this.#falseText	= this.getAttribute("false-text") || "";//this.falseValue;
		this.#isRadio	= (this.getAttribute("is-radio") == "true") ? true : false;
	}
	
	connectedCallback() {

		const align					= this.closest("th,td").getAttribute("text-align") || "center";
		const justifyContent		= align == "left" ? "flex-start" : (align == "right" ? "flex-end" : "center");
		const flexDirection			= align == "right" ? "row-reverse" : "unset";
		const selectedBorderColor	= this.getAttribute("selected-border-color") || "dimgray";
		const childHtml				= "<label>" + (!this.#isRadio ? `<input type="checkbox">` : `<input type="radio" value="${this.trueValue}">`) + "<span></span></label>";

		this.shadowRoot.innerHTML = `
			<style>
				:host {
					justify-content: ${this.closest("th,td").getAttribute("text-align") || "center"};
				}
				:host-context(.selected) input {
					border: 1px solid ${selectedBorderColor} !important;
				}
				label {
					flex-direction: ${flexDirection};
				}
				div.ng-wrap {
					justify-content: ${justifyContent};
				}
				:host-context(.selected) input[type=checkbox]:checked {
					background-image: url('data:image/svg+xml;utf8,<svg height="14" width="14" xmlns="http://www.w3.org/2000/svg"><polyline points="2.5,7 6,10 11,3" style="fill:none;stroke:${selectedBorderColor};stroke-width:2" /></svg>');
				}
			</style>
			<div class="ng-wrap">
				${childHtml}
			</div>
		`;

		super.connectedCallback();
		
		this.#target = this.shadowRoot.querySelector("input");
		this.#label = this.shadowRoot.querySelector("span");
		
		if (this.closest("thead")) {
			$(this.#target).on("change", e => {
				
				var cell = this.owner.body.querySelector(`.ng-table tbody.bindable [data-col="${this.cell.dataset.col}"]`)
				if (cell) cell.querySelector("ng-checkbox").selectAll($(e.target).is(':checked'));
			});
		};
		

		$(this.cell).on("keydown", e => {
			e.preventDefault();

			switch (e.code) {
			case "Space":
				this.value = this.value == this.trueValue ? this.falseValue : this.trueValue;
				break;
			}
		});
	};
	
	get dataSource() {
		//var t = this.getAttribute("true-value") || "Y";
		//var f = this.getAttribute("false-value") || "N";
		
		//return [{value : t, text : t}, {value : f, text : f}];
		
		return [{value : this.trueValue, text : this.#trueText}, {value : this.falseValue, text : this.#falseText}];
	};
	
	dataRefresh = (v) => {
		
		if (!this.closest("tbody")) return;
		
		if (ninegrid.isNull(this.value) || this.value == this.trueValue || this.value == this.falseValue) {
			ninegrid.j.querySelectorAll(this).removeClass("invalid");
		}
		else {
			ninegrid.j.querySelectorAll(this).addClass("invalid");
		}
		
		$(this.#target).prop("checked", this.value == this.trueValue);
		if (this.#label) $(this.#label).html(this.value == this.trueValue ? this.#trueText : (this.value == this.falseValue ? this.#falseText : this.value) );
		
		if (!v) this.reset();
	};
	
	selectAll = (v) => {

		var enableFn	= this.getAttribute('enable') || this.cell.getAttribute('enable');
		var readonlyFn	= this.getAttribute('readonly') || this.cell.getAttribute('readonly');
		var visibleFn	= this.getAttribute('visible') || this.cell.getAttribute('visible');

		if (enableFn) enableFn = this.owner.exprFunction2(enableFn);
		if (readonlyFn) readonlyFn = this.owner.exprFunction2(readonlyFn);//new Function('data', 'currow', 'return ' + enableFn + ';');
		if (visibleFn) visibleFn = this.owner.exprFunction2(visibleFn);

		var data = this.owner.data.getValidData();

		const COL_IDX = this.owner.fields.indexOf(this.cell.dataset.bind);

		for (var i = 0; i < data.length; i++) {

			if (enableFn && enableFn(data[i], i) == false) continue;
			if (readonlyFn && readonlyFn(data[i], i) == true) continue;
			if (visibleFn && visibleFn(data[i], i) == false) continue;

			data[i].v[COL_IDX] = v ? this.trueValue : this.falseValue;
		};

		this.owner.view.redraw();
	};
}

if (!customElements.get('ng-checkbox')) {
	customElements.define("ng-checkbox", ngCheckBox);
}